import { render } from "./ShapeArrange.vue?vue&type=template&id=5710691d&scoped=true"
import script from "./ShapeArrange.vue?vue&type=script&lang=js"
export * from "./ShapeArrange.vue?vue&type=script&lang=js"

import "./ShapeArrange.vue?vue&type=style&index=0&id=5710691d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5710691d"]])

export default __exports__